import { render, staticRenderFns } from "./Rta.vue?vue&type=template&id=0da744f2&scoped=true"
import script from "./Rta.vue?vue&type=script&lang=js"
export * from "./Rta.vue?vue&type=script&lang=js"
import style0 from "./Rta.vue?vue&type=style&index=0&id=0da744f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da744f2",
  null
  
)

export default component.exports